import Enums from 'utils/EnumsManager';
import Column from './Column';

const { GROUPS, OTHERS, AGGREGATES } = Enums.DROPZONES;

const toModel = data => {
  if (!_.isArray(data)) {
    return [];
  }
  return data.map(
    record =>
      new Column({
        id: record.id,
        name: record.field_name,
        type: record.crm_data_type,
        label: record.field_label,
        lookupKey: record.lookup_own_field_name,
        fieldRestricted: record.is_restricted_to_me
      })
  );
};

const checkRestriction = (filters, store) => {
  const { availableColumns } = store.reportSetup.sider;
  return filters.map(filter => {
    const filterInfo = availableColumns.find(col => col.id === filter.id);
    return {
      ...filter,
      // map the sytle of setup criteria
      is_restricted_to_me: filterInfo && filterInfo.fieldRestricted
    };
  });
};

const sortSelectedCols = (selectedCols, group_by, selectors, aggregations) => {
  const sortedData = [];
  if (_.isArray(group_by)) {
    group_by.forEach(g => {
      const group = _.find(selectedCols, { name: g.field_name });
      if (group) {
        sortedData.push(group);
      } else {
        sortedData.push(new Column({
          id: g.field_name,
          name: g.field_name,
          label: g.field_name,
          disabled: true,
          belongTo: GROUPS,
          fieldDeleted: true,
        }));
      }
    });
  }
  if (_.isArray(selectors)) {
    selectors.forEach(s => {
      const selector = _.find(selectedCols, { name: s });
      if (selector) {
        sortedData.push(selector);
      } else {
        sortedData.push(new Column({
          id: s,
          name: s,
          label: s,
          disabled: true,
          belongTo: OTHERS,
          fieldDeleted: true,
        }));
      }
    });
  }
  if (_.isArray(aggregations)) {
    aggregations.forEach(a => {
      const aggregation = _.find(selectedCols, { name: a.field_name });
      if (aggregation) {
        sortedData.push(aggregation);
      } else {
        sortedData.push(new Column({
          id: a.field_name,
          name: a.field_name,
          label: a.field_name,
          disabled: true,
          belongTo: AGGREGATES,
          fieldDeleted: true,
        }));
      }
    });
  }
  return sortedData;
};

export { Column, toModel, checkRestriction, sortSelectedCols };



// WEBPACK FOOTER //
// ./src/views/ReportSetup/utils/index.js